import { _ as _type_of } from "@swc/helpers/_/_type_of";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildWorkletsHash = buildWorkletsHash;
exports.validateAnimatedStyles = exports.useHandler = exports.useEvent = exports.shallowEqual = exports.isAnimated = void 0;
var _react = require("react");
var _core = require("../core");
var _PlatformChecker = require("../PlatformChecker");
var _WorkletEventHandler = _interopRequireDefault(require("../WorkletEventHandler"));
var useEvent = exports.useEvent = function useEvent(handler) {
    var eventNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var rebuild = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var initRef = (0, _react.useRef)(null);
    if (initRef.current === null) {
        initRef.current = new _WorkletEventHandler.default(handler, eventNames);
    } else if (rebuild) {
        initRef.current.updateWorklet(handler);
    }
    return initRef;
};
var useHandler = exports.useHandler = function useHandler(handlers, dependencies) {
    var initRef = (0, _react.useRef)(null);
    if (initRef.current === null) {
        initRef.current = {
            context: (0, _core.makeRemote)({}),
            savedDependencies: []
        };
    }
    (0, _react.useEffect)(function() {
        return function() {
            initRef.current = null;
        };
    }, []);
    var _initRef$current = initRef.current, context = _initRef$current.context, savedDependencies = _initRef$current.savedDependencies;
    dependencies = buildDependencies(dependencies, handlers);
    var doDependenciesDiffer = !areDependenciesEqual(dependencies, savedDependencies);
    initRef.current.savedDependencies = dependencies;
    var useWeb = (0, _PlatformChecker.isWeb)() || (0, _PlatformChecker.isJest)();
    return {
        context: context,
        doDependenciesDiffer: doDependenciesDiffer,
        useWeb: useWeb
    };
};
function buildWorkletsHash(handlers) {
    return Object.values(handlers).reduce(function(acc, worklet) {
        return acc + worklet.__workletHash.toString();
    }, "");
}
function buildDependencies(dependencies, handlers) {
    var handlersList = Object.values(handlers).filter(function(handler) {
        return handler !== undefined;
    });
    if (!dependencies) {
        dependencies = handlersList.map(function(handler) {
            return {
                workletHash: handler.__workletHash,
                closure: handler.__closure
            };
        });
    } else {
        dependencies.push(buildWorkletsHash(handlersList));
    }
    return dependencies;
}
function areDependenciesEqual(nextDeps, prevDeps) {
    function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (!nextDeps || !prevDeps || prevDeps.length !== nextDeps.length) {
            return false;
        }
        for(var i = 0; i < prevDeps.length; ++i){
            if (!objectIs(nextDeps[i], prevDeps[i])) {
                return false;
            }
        }
        return true;
    }
    return areHookInputsEqual(nextDeps, prevDeps);
}
var _worklet_10902818434400_init_data = {
    code: "function isAnimated(prop){const isAnimated=this._recur;if(Array.isArray(prop)){return prop.some(isAnimated);}else if(typeof prop==='object'&&prop!==null){if(prop.onFrame!==undefined){return true;}else{return Object.values(prop).some(isAnimated);}}return false;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/utils.ts",
    sourceMap: '{"version":3,"names":["isAnimated","prop","_recur","Array","isArray","some","onFrame","undefined","Object","values"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/utils.ts"],"mappings":"AA4JO,SAAAA,UAASA,CAAWC,IAAA,CAA0C,OAAAD,UAAA,MAAAE,MAAA,CAEnE,GAAIC,KAAK,CAACC,OAAO,CAACH,IAAI,CAAC,CAAE,CACvB,MAAO,CAAAA,IAAI,CAACI,IAAI,CAACL,UAAU,CAAC,CAC9B,CAAC,IAAM,IAAI,MAAO,CAAAC,IAAI,GAAK,QAAQ,EAAIA,IAAI,GAAK,IAAI,CAAE,CACpD,GAAIA,IAAI,CAACK,OAAO,GAAKC,SAAS,CAAE,CAC9B,MAAO,KAAI,CACb,CAAC,IAAM,CACL,MAAO,CAAAC,MAAM,CAACC,MAAM,CAACR,IAAI,CAAC,CAACI,IAAI,CAACL,UAAU,CAAC,CAC7C,CACF,CACA,MAAO,MAAK,CACd"}',
    version: "3.5.4"
};
var isAnimated = exports.isAnimated = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var isAnimated = function isAnimated(prop) {
        if (Array.isArray(prop)) {
            return prop.some(isAnimated);
        } else if (typeof prop === "object" && prop !== null) {
            if (prop.onFrame !== undefined) {
                return true;
            } else {
                return Object.values(prop).some(isAnimated);
            }
        }
        return false;
    };
    isAnimated.__closure = {};
    isAnimated.__initData = _worklet_10902818434400_init_data;
    isAnimated.__workletHash = 10902818434400;
    isAnimated.__stackDetails = _e;
    return isAnimated;
}();
var _worklet_14833023826026_init_data = {
    code: "function shallowEqual(a,b){const aKeys=Object.keys(a);const bKeys=Object.keys(b);if(aKeys.length!==bKeys.length){return false;}for(let i=0;i<aKeys.length;i++){if(a[aKeys[i]]!==b[aKeys[i]]){return false;}}return true;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/utils.ts",
    sourceMap: '{"version":3,"names":["shallowEqual","a","b","aKeys","Object","keys","bKeys","length","i"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/utils.ts"],"mappings":"AA0KO,SAAAA,YAASA,CAAaC,CAAC,CAAKC,CAAG,CAAK,CAEzC,KAAM,CAAAC,KAAK,CAAGC,MAAM,CAACC,IAAI,CAACJ,CAAC,CAAC,CAC5B,KAAM,CAAAK,KAAK,CAAGF,MAAM,CAACC,IAAI,CAACH,CAAC,CAAC,CAC5B,GAAIC,KAAK,CAACI,MAAM,GAAKD,KAAK,CAACC,MAAM,CAAE,CACjC,MAAO,MAAK,CACd,CACA,IAAK,GAAI,CAAAC,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAGL,KAAK,CAACI,MAAM,CAAEC,CAAC,EAAE,CAAE,CACrC,GAAIP,CAAC,CAACE,KAAK,CAACK,CAAC,CAAC,CAAC,GAAKN,CAAC,CAACC,KAAK,CAACK,CAAC,CAAC,CAAC,CAAE,CAC/B,MAAO,MAAK,CACd,CACF,CACA,MAAO,KAAI,CACb"}',
    version: "3.5.4"
};
var shallowEqual = exports.shallowEqual = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var shallowEqual = function shallowEqual(a, b) {
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) {
            return false;
        }
        for(var i = 0; i < aKeys.length; i++){
            if (a[aKeys[i]] !== b[aKeys[i]]) {
                return false;
            }
        }
        return true;
    };
    shallowEqual.__closure = {};
    shallowEqual.__initData = _worklet_14833023826026_init_data;
    shallowEqual.__workletHash = 14833023826026;
    shallowEqual.__stackDetails = _e;
    return shallowEqual;
}();
var _worklet_6843084571063_init_data = {
    code: "function anonymous(styles){if(typeof styles!=='object'){throw new Error(\"[Reanimated] `useAnimatedStyle` has to return an object, found \"+typeof styles+\" instead.\");}else if(Array.isArray(styles)){throw new Error('[Reanimated] `useAnimatedStyle` has to return an object and cannot return static styles combined with dynamic ones. Please do merging where a component receives props.');}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/utils.ts",
    sourceMap: '{"version":3,"names":["anonymous","styles","Error","Array","isArray"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/utils.ts"],"mappings":"AAyLsC,QAAC,CAAAA,SAA2BA,CAAUC,MAAA,EAE1E,GAAI,MAAO,CAAAA,MAAM,GAAK,QAAQ,CAAE,CAC9B,KAAM,IAAI,CAAAC,KAAK,mEACuD,MAAO,CAAAD,MAAO,YACpF,CAAC,CACH,CAAC,IAAM,IAAIE,KAAK,CAACC,OAAO,CAACH,MAAM,CAAC,CAAE,CAChC,KAAM,IAAI,CAAAC,KAAK,CACb,yKACF,CAAC,CACH,CACF"}',
    version: "3.5.4"
};
var validateAnimatedStyles = exports.validateAnimatedStyles = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous(styles) {
        if (typeof styles !== "object") {
            throw new Error("[Reanimated] `useAnimatedStyle` has to return an object, found ".concat(typeof styles === "undefined" ? "undefined" : _type_of(styles), " instead."));
        } else if (Array.isArray(styles)) {
            throw new Error("[Reanimated] `useAnimatedStyle` has to return an object and cannot return static styles combined with dynamic ones. Please do merging where a component receives props.");
        }
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_6843084571063_init_data;
    anonymous.__workletHash = 6843084571063;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
